import { isEmpty } from 'lodash';
import moment from 'moment';
import { constants } from '@clubmed/utils';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { formatPhoneNumber, getPhoneNumber } from './phoneUtils';
const { BOOKING_STATUSES } = constants;
type getAgencyDetailsType = {
  dedicatedJoyviewHotlineNumber: string | null | undefined;
  isJoyview: boolean | null | undefined;
  vendor: BookingVendor;
};

function getAgencyDetails({
  vendor,
  dedicatedJoyviewHotlineNumber,
  isJoyview,
}: getAgencyDetailsType): {
  url: string | null | undefined;
  label: string | null | undefined;
} {
  const agencyPhoneNumber =
    isJoyview && !isEmpty(dedicatedJoyviewHotlineNumber)
      ? dedicatedJoyviewHotlineNumber
      : getPhoneNumber(vendor, t('travelAdvisor.phoneNumber'));
  return {
    label: agencyPhoneNumber,
    url: formatPhoneNumber(agencyPhoneNumber),
  };
}

function isPastTrip(returnDate: string): boolean {
  if (!returnDate) {
    return false;
  }

  return moment(Date.now()).isAfter(moment(returnDate, 'YYYYMMDD'));
}

const isArchived = (bookingStatus: BookingStatus) =>
  bookingStatus === BOOKING_STATUSES.BOOKING_STATUS_ARCHIVED;

function getTranportIcon(transportType?: string) {
  switch (transportType) {
    case 'TRAIN':
      return ICONS.TRAIN;

    case 'BOAT':
    case 'FERRY':
      return ICONS.BOAT;

    default:
      return ICONS.TRANSPORT;
  }
}

export { getAgencyDetails, getTranportIcon, isArchived, isPastTrip };
